<div class="card resume-check-card">
  <div class="card-body">
    <h5>
      {{ 'Common.ResumeSubscriptionProcessTitle' | labelText : productName }}
    </h5>

    @if (showOtpCheck) {
      <app-otp-check [prefilledUserId]="userId" [prefilledSessionId]="sessionId" [showCancel]="false" [centerSubmitButton]="true"></app-otp-check>
    }

    @if (otpRequestFailed) {
      <p class="resume-check-message">Impossible d'envoyer le code de verification.</p>
    }
  </div>
</div>
